export default __webpack_public_path__ + "static/media/male-photo2.ff3d3d54.jpg";